import { getCurrencySymbol, getNumberFormat } from "../../../../utils";
import {
  Amount,
  DesktopGroupCount,
  DesktopGroupHeaderLeft,
  DesktopGroupHeaderRow,
  DesktopGroupTitle,
  MobileGroupCount,
  MobileGroupHeader,
  MobileGroupLeft,
  MobileGroupTitle,
} from "./styles";
import { AmountVariant, GroupHeaderProps } from "./types";
import { formatGroupDate } from "./utils";

const netVariant = (net: number): AmountVariant => {
  if (net > 0) {
    return "income";
  }
  if (net < 0) {
    return "expense";
  }
  return "neutral";
};

const getNetSign = (net: number): string => {
  if (net > 0) {
    return "+";
  }
  if (net < 0) {
    return "-";
  }
  return "";
};

const formatNet = (net: number, currencyCode: string): string => {
  const sign = getNetSign(net);
  const symbol = getCurrencySymbol(currencyCode);
  return `${sign}${getNumberFormat(Math.abs(net))} ${symbol}`;
};

export const GroupHeader: React.FC<GroupHeaderProps> = ({ group, variant }) => {
  const count = group.transactions.length;
  const currencyCode = group.transactions[0]?.currencyCode ?? "EUR";
  const amountVariant = netVariant(group.dailyNet);
  const amountText = formatNet(group.dailyNet, currencyCode);
  const title = formatGroupDate(group.dateKey);

  if (variant === "mobile") {
    const countLabel = `${count} tx`;
    return (
      <MobileGroupHeader>
        <MobileGroupLeft>
          <MobileGroupTitle>{title}</MobileGroupTitle>
          <MobileGroupCount>{countLabel}</MobileGroupCount>
        </MobileGroupLeft>
        <Amount $variant={amountVariant} $bold>
          {amountText}
        </Amount>
      </MobileGroupHeader>
    );
  }

  const countLabel = `${count} ${count === 1 ? "transaction" : "transactions"}`;
  return (
    <DesktopGroupHeaderRow>
      <DesktopGroupHeaderLeft>
        <DesktopGroupTitle>{title}</DesktopGroupTitle>
        <DesktopGroupCount>{countLabel}</DesktopGroupCount>
      </DesktopGroupHeaderLeft>
      <Amount $variant={amountVariant} $bold>
        {amountText}
      </Amount>
    </DesktopGroupHeaderRow>
  );
};
